// Automatisch aus config/app.config.json erzeugt. Nicht manuell ändern.
export const appConfig = {
  "appName": "WohnBau Zählerablesung",
  "appVersion": "1.86.1",
  "tenantId": "104e3b10-cc5c-4160-ae68-97dc6ffa1675",
  "clientId": "c48fa2b5-b5af-4eb9-80e4-7a12c210a945",
  "teamsAppId": "fb8459b5-8337-4081-8551-d62d5b238ab3",
  "apiApplicationIdUri": "api://calm-grass-02b5c4203.1.azurestaticapps.net/c48fa2b5-b5af-4eb9-80e4-7a12c210a945",
  "functionUrl": "https://func-zaehlerablesung-f7and4dpdjgubgg5.germanywestcentral-01.azurewebsites.net/api",
  "frontendUrl": "https://calm-grass-02b5c4203.1.azurestaticapps.net",
  "pwaUrl": "https://zaehlerablesung.wohnbau.it",
  "sharePointSiteUrl": "https://wohnbauwml.sharepoint.com/sites/ABT_Finanzen-Organisation",
  "sharePointList": "PV-Ablesungen",
  "sharePointPhotoLibrary": "PV-Zählerbilder",
  "ocrEnabled": false,
  "ocrResourceName": "cv-pv-zaehlerablesung",
  "ocrApiVersion": "2024-02-01",
  "roles": {
    "reader": "PV.Ableser",
    "admin": "PV.Verwaltung",
    "settings": "PV.Einstellungen"
  },
  "photo": {
    "maxEdgePx": 1600,
    "jpegQuality": 0.82,
    "maxUploadBytes": 4194304
  },
  "manifestVersion": "1.5.1",
  "baselineVersion": "1.174.0"
} as const;
